type Callback = () => void

let isBrowserUpdatingFrame = false
const scrollCallbacks: Array<Callback> = []

/**
 * Checks if the window scroll has changed and triggers the callback functions if
 * @returns Returns `false` if the window scroll hasn't changed, otherwise `undefined`.
 */
const runCallbacks = () => {
	for (const callback of scrollCallbacks) {
		callback()
	}

	isBrowserUpdatingFrame = false
}

/**
 * Adds a scroll event listener to the window
 */
const addListenerScroll = () => {
	window.addEventListener('scroll', onScroll, {
		passive: true
	})
}

export default (callback: Callback) => {
	scrollCallbacks.push(callback)
	addListenerScroll()
}

const onScroll = () => {
	if (!isBrowserUpdatingFrame) {
		requestAnimationFrame(runCallbacks)
		isBrowserUpdatingFrame = true
	}
}

/**
 * Removes a window scroll listener.
 * @param callback - The callback function to be removed.
 */
const removeWindowScrollListener = (callback: Callback) => {
	scrollCallbacks.splice(scrollCallbacks.indexOf(callback), 1)
}

export { removeWindowScrollListener }
